import { ChangelogReportBreadcrumb } from "@/components/changelog-report-breadcrumb"
import { SiteHeader } from "@/components/site-header"
import { Badge } from "@/components/ui/badge"

/** db:fresh + db:seed + db:seed:routes — 2026-05-11 */
const RUN = {
  date: "2026-05-11",
  sourcePath: "apps/api/data/20160511/trayectos-202600511.txt",
  fileLines: 7203,
  inserted: 6144,
  skippedExisting: 0,
  unresolved: 1052,
}

const TOP_MISSING_CITY_CODES: { code: string; trayectos: number }[] = [
  { code: "URUGUAIANA", trayectos: 284 },
  { code: "PASO DE LO", trayectos: 252 },
  { code: "JACAREI", trayectos: 44 },
  { code: "UBERLANDIA", trayectos: 35 },
  { code: "SAO", trayectos: 30 },
  { code: "PAULINIA", trayectos: 30 },
  { code: "VILLA REGI", trayectos: 17 },
  { code: "CACHO", trayectos: 16 },
  { code: "TIO PUJIO", trayectos: 16 },
  { code: "VILLAZON", trayectos: 14 },
  { code: "IJUI", trayectos: 13 },
  { code: "SAN JOSE", trayectos: 13 },
  { code: "PORTO ALEG", trayectos: 12 },
  { code: "BUENOS AIR", trayectos: 11 },
  { code: "AVELLANEDA", trayectos: 10 },
  { code: "CASANOVA", trayectos: 10 },
  { code: "SF DE PAUL", trayectos: 10 },
  { code: "GUAIRA", trayectos: 9 },
  { code: "RIO CLARO", trayectos: 9 },
  { code: "LA PAZ", trayectos: 8 },
]

export default function RoutesImportReportPage() {
  return (
    <>
      <SiteHeader
        title="Importación"
        breadcrumb={<ChangelogReportBreadcrumb currentLabel="Trayectos · 2026-05-11" />}
      />
      <div className="flex flex-1 flex-col px-4 py-6 lg:px-6">
        <div className="max-w-5xl space-y-10">
          <div className="space-y-3 rounded-lg border border-emerald-200 bg-emerald-50/80 dark:bg-emerald-950/20 dark:border-emerald-900 p-4 text-sm">
            <p className="font-medium text-foreground">Estado verificado ({RUN.date})</p>
            <p className="text-muted-foreground">
              Archivo por defecto:{" "}
              <code className="font-mono text-xs bg-muted px-1.5 py-0.5 rounded">{RUN.sourcePath}</code> (
              {RUN.fileLines} líneas; cabecera TSV + filas de datos). El seeder es{" "}
              <code className="font-mono text-xs bg-muted px-1 rounded">apps/api/src/db/seeds/routes.ts</code>
              : resuelve origen y destino contra <code className="font-mono text-xs bg-muted px-1 rounded">cities.code</code>{" "}
              (mayúsculas) y guarda <code className="font-mono text-xs bg-muted px-1 rounded">name</code> con el mismo
              formato título que las ciudades.
            </p>
            <p className="text-muted-foreground">
              Salida útil: <strong className="text-foreground">consola</strong> (resumen final + bloque «Códigos de
              ciudad no encontrados» ordenado por frecuencia). No se genera archivo Markdown automáticamente.
            </p>
          </div>

          <section>
            <h2 className="text-base font-semibold mb-3">Resumen ({RUN.date})</h2>
            <p className="text-sm text-muted-foreground mb-3">
              Tras cargar geografía y ciudades con <code className="font-mono text-xs bg-muted px-1 rounded">bun run db:seed</code>{" "}
              y ejecutar <code className="font-mono text-xs bg-muted px-1 rounded">bun run db:seed:routes</code>.
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
              {[
                { label: "Rutas insertadas", value: String(RUN.inserted), color: "text-green-700" },
                { label: "Ya existían (code)", value: String(RUN.skippedExisting), color: "text-muted-foreground" },
                { label: "Filas no resueltas", value: String(RUN.unresolved), color: "text-red-600" },
                {
                  label: "Filas TSV con trayecto+descrip",
                  value: String(RUN.inserted + RUN.unresolved),
                  color: "text-muted-foreground",
                },
              ].map((s) => (
                <div key={s.label} className="rounded-lg border p-3">
                  <p className={`text-2xl font-bold tabular-nums ${s.color}`}>{s.value}</p>
                  <p className="text-xs text-muted-foreground mt-0.5">{s.label}</p>
                </div>
              ))}
            </div>
          </section>

          <section>
            <div className="flex items-center gap-2 mb-3">
              <Badge variant="outline" className="text-amber-600 border-amber-300">
                Top códigos
              </Badge>
              <h2 className="text-base font-semibold">Ciudad más citada sin coincidencia en DB</h2>
            </div>
            <p className="text-sm text-muted-foreground mb-3">
              Origen o destino del TSV no encontró fila en <code className="font-mono text-xs bg-muted px-1 rounded">cities</code>{" "}
              con ese <code className="font-mono text-xs bg-muted px-1 rounded">code</code> (truncamiento, typo o ciudad aún no
              importada). Extracto de la última corrida; la lista completa sale en consola.
            </p>
            <div className="rounded-lg border overflow-hidden">
              <table className="w-full text-sm">
                <thead className="bg-muted/50">
                  <tr>
                    <th className="text-left px-3 py-2 font-medium">Código en TSV</th>
                    <th className="text-right px-3 py-2 font-medium">Apariciones en trayectos fallidos</th>
                  </tr>
                </thead>
                <tbody className="divide-y">
                  {TOP_MISSING_CITY_CODES.map((r) => (
                    <tr key={r.code}>
                      <td className="px-3 py-2 font-mono text-xs">{r.code}</td>
                      <td className="px-3 py-2 text-right tabular-nums text-muted-foreground">{r.trayectos}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>

          <section>
            <h2 className="text-base font-semibold mb-4">Cómo importar trayectos</h2>
            <ol className="space-y-4 text-sm">
              <li className="flex gap-3">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-muted text-xs font-bold">
                  1
                </span>
                <div>
                  <p className="font-medium">Archivo fuente</p>
                  <p className="text-muted-foreground mt-0.5">
                    Por defecto se usa{" "}
                    <code className="font-mono text-xs bg-muted px-1.5 py-0.5 rounded">{RUN.sourcePath}</code>. Podés
                    pasar otra ruta como argumento (absoluta o relativa al cwd de{" "}
                    <code className="font-mono text-xs bg-muted px-1 rounded">apps/api</code>).
                  </p>
                  <p className="text-muted-foreground mt-1">TSV con cabecera:</p>
                  <pre className="mt-1.5 rounded bg-muted px-3 py-2 text-xs font-mono overflow-x-auto">
                    trayecto{"\t"}descrip{"\t"}origen{"\t"}destino
                  </pre>
                </div>
              </li>
              <li className="flex gap-3">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-muted text-xs font-bold">
                  2
                </span>
                <div>
                  <p className="font-medium">Ejecutar el seeder</p>
                  <pre className="mt-1.5 rounded bg-muted px-3 py-2 text-xs font-mono whitespace-pre-wrap">
                    {`cd apps/api
bun run db:seed:routes

# Archivo alternativo:
bun run src/db/seeds/routes.ts data/20160511/otro.tsv`}
                  </pre>
                </div>
              </li>
              <li className="flex gap-3">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-muted text-xs font-bold">
                  3
                </span>
                <div>
                  <p className="font-medium">Revisar consola</p>
                  <ul className="mt-2 space-y-1 text-muted-foreground list-disc list-inside">
                    <li>Insertados / ya existían / no resueltos</li>
                    <li>Códigos de ciudad no encontrados (frecuencia)</li>
                  </ul>
                </div>
              </li>
              <li className="flex gap-3">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-muted text-xs font-bold">
                  4
                </span>
                <div>
                  <p className="font-medium">Resolver ciudades faltantes</p>
                  <p className="text-muted-foreground mt-0.5">
                    Alta en <strong>Geografía → Ciudades</strong> o corrección del TSV / de{" "}
                    <code className="font-mono text-xs bg-muted px-1 rounded">cities-data.ts</code>; volver a correr el
                    seeder de rutas — los trayectos ya insertados se omiten por <code className="font-mono text-xs bg-muted px-1 rounded">routes.code</code> único.
                  </p>
                </div>
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-base font-semibold mb-3">Mapeo de columnas</h2>
            <div className="rounded-lg border overflow-hidden">
              <table className="w-full text-sm">
                <thead className="bg-muted/50">
                  <tr>
                    <th className="text-left px-4 py-2.5 font-medium">Columna en archivo</th>
                    <th className="text-left px-4 py-2.5 font-medium">Campo en DB</th>
                    <th className="text-left px-4 py-2.5 font-medium">Descripción</th>
                  </tr>
                </thead>
                <tbody className="divide-y">
                  {[
                    { col: "trayecto", field: "code", desc: "Código único del trayecto (se normaliza a MAYÚSCULAS)" },
                    { col: "descrip", field: "name", desc: "Texto mostrado; se aplica formato título por « / »" },
                    { col: "origen", field: "origin_city_id", desc: "Debe coincidir con cities.code (mayúsculas)" },
                    { col: "destino", field: "target_city_id", desc: "Ídem" },
                  ].map((r) => (
                    <tr key={r.col}>
                      <td className="px-4 py-2.5 font-mono text-xs">{r.col}</td>
                      <td className="px-4 py-2.5 font-mono text-xs text-blue-600">{r.field}</td>
                      <td className="px-4 py-2.5 text-muted-foreground">{r.desc}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <p className="mt-2 text-xs text-muted-foreground">
              Si el mismo <code className="font-mono">code</code> aparece en más de una provincia, gana la primera
              encontrada en la carga del mapa en memoria.
            </p>
          </section>
        </div>
      </div>
    </>
  )
}
